import Vue from 'vue'
import App from './App.vue'

Vue.config.productionTip = false

import VueSlider from 'vue-slider-component'
import 'vue-slider-component/theme/default.css'
import VueJSModal from "vue-js-modal";

var numeral = require("numeral");

numeral.register('locale', 'de', {
  delimiters: {
    thousands: '.',
    decimal: ','
  },
  abbreviations: {
    thousand: 'k',
    million: 'm',
    billion: 'b',
    trillion: 't'
  },
  ordinal : function (number) {
    return number === 1 ? 'er' : 'ème';
  },
  currency: {
    symbol: '€'
  }
});

Vue.use(VueJSModal, { dialog: true });

numeral.locale('de');


Vue.filter("formatNumber", function (value) {
  return numeral(value).format("0,0"); // displaying other groupings/separators is possible, look at the docs
});


Vue.component('VueSlider', VueSlider)


new Vue({
  render: h => h(App),
}).$mount('#app')
